var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59013 12.0454C2.8011 12.2563 3.08719 12.3748 3.3855 12.3748C3.68381 12.3748 3.96991 12.2563 4.18088 12.0454L9.74963 6.47662L15.3184 12.0454C15.5306 12.2503 15.8147 12.3637 16.1097 12.3611C16.4047 12.3586 16.6868 12.2403 16.8954 12.0317C17.104 11.8231 17.2223 11.5409 17.2249 11.2459C17.2274 10.951 17.1141 10.6668 16.9091 10.4546L10.545 4.0905C10.334 3.87959 10.0479 3.76111 9.74963 3.76111C9.45132 3.76111 9.16522 3.87959 8.95425 4.0905L2.59013 10.4546C2.37922 10.6656 2.26074 10.9517 2.26074 11.25C2.26074 11.5483 2.37922 11.8344 2.59013 12.0454Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.d1194fe86685b5e4fca5095b9c239119.svg";
export { ForwardRef as ReactComponent };